<ng-template let-data="adtData" let-emitter="captureEvents" #volunteerActionCell>
    <app-volunteer-action-cell [data]="data" (emitter)="emitter($event)" [readonly]="readonly"></app-volunteer-action-cell>
</ng-template>

<ng-template let-data="adtData" #volunteerStatusCell>
    <app-volunteer-status-cell [data]="data"></app-volunteer-status-cell>
</ng-template>

<div style="margin-top: 3rem;">
    <app-header title="Volunteers"></app-header>

    <header class="px-4 pt-5">
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="headline-4">Volunteers</div>
            <div *ngIf="!this.readonly" class="d-flex align-items-center">
                <button (click)="onClickImport()" class="btn btn--paybee btn-sm modal-confirm-button mr-3">Bulk Add</button>
                <button id="addNewVolunteer" class="btn btn--paybee btn-sm modal-confirm-button">Add New Volunteer...</button>
            </div>
        </div>
        <span class="grey-text subtitle-1">View and edit volunteers so they can use the PayBee app on behalf of your organization</span>
    </header>

    <div class="p-4">
        <div class="table--paybee">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table">
                <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Status</th>
                        @if(!readonly) {
                            <th></th>
                        }
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</div>
